import spaHelper from '../helpers/spa'

export default {
    methods: spaHelper
}
